<!-- eslint-disable vue/no-restricted-html-elements -->
<template>
  <button
    class="brand-tile"
    type="button"
    :style="{ backgroundColor }"
    :aria-label="$variable('store.shopName')"
    @click.prevent="brandTileActive = !brandTileActive"
  >
    <transition name="fade">
      <div
        v-if="brandTileActive"
        class="brand-tile__items"
      >
        <div
          v-for="(item, index) of brandTiles"
          :key="index"
          class="brand-tile__item text-center"
        >
          <div
            v-if="item.icon && item.icon !== 'none'"
            class="brand-tile__icon"
          >
            <component :is="getBrandTileIcon(item.icon)" />
          </div>

          <p
            class="brand-tile__text text-heading-s"
            v-text="item.text"
          />
        </div>
      </div>

      <div
        v-else
        class="brand-tile__items"
      >
        <icon-childsplay />
      </div>
    </transition>
  </button>
</template>

<script>

/**
 * Vue: Brand tile (product-gallery-carousel)
 * -----------------------------------------------------------------------------
 * Desktop-only brand tile in product gallery.
 *
 * @param {String} backgroundColor - Background colour for brand tile.
 * @param {Array} brandTiles - Brand tiles content.
 *
 *
 */
import IconChildsplay from '~icons/misc/childsplay.svg'
import IconDelivery from '~icons/misc/delivery.svg'
import IconOnesie from '~icons/misc/onesie.svg'
import IconPadlock from '~icons/misc/padlock.svg'
import IconReturns from '~icons/misc/returns.svg'

export default {
  name: 'BrandTile',

  components: {
    IconChildsplay,
    IconDelivery,
    IconOnesie,
    IconPadlock,
    IconReturns,
  },

  props: {
    backgroundColor: {
      type: String,
      default: '#f4f4f4',
    },
    brandTiles: {
      type: Array,
      default: () => [],
      required: true,
    },
  },

  data() {
    return {
      brandTileActive: false,
    }
  },

  methods: {

    /**
     * Get brand tile Vue icon component.
     * @param {String} icon - Setting icon value.
     * @returns {String}
     */
    getBrandTileIcon(icon) {
      return `icon-${icon.split('.')[1]}`
    },
  },
}
</script>

<style lang="scss">
@import './brand-tile';
</style>
